<template>
  <fieldset :disabled="disabled" class="bonus-limits-editor">
    <b-form-checkbox :checked="customChips" :disabled="disabled" class="mb-3" @change="toggleChips">Custom bonus chips</b-form-checkbox>
    <template v-if="customChips">
      <b-row v-for="(chip, index) in settings.bonusChips" :key="index" class="align-items-end">
        <b-col cols="10" sm="6">
          <b-form-group :label="'Bonus chip ' + (index + 1)" :label-for="'bonus-chip-' + _uid + '-' + index">
            <b-form-input :id="'bonus-chip-' + _uid + '-' + index" v-model.number="chip.nominal" type="number" min="0" step="any" :disabled="disabled" required />
          </b-form-group>
        </b-col>
        <b-col cols="2" class="mb-3">
          <b-button type="button" variant="outline-danger" :disabled="disabled || settings.bonusChips.length === 1" :aria-label="'Remove bonus chip ' + (index + 1)" title="Remove bonus chip" @click="settings.bonusChips.splice(index, 1)"><i class="fas fa-trash" aria-hidden="true"></i></b-button>
        </b-col>
      </b-row>
      <b-button type="button" size="sm" variant="outline-primary" class="mb-3" :disabled="disabled" @click="addChip"><i class="fas fa-plus" aria-hidden="true"></i> Add bonus chip</b-button>
    </template>
    <b-form-checkbox :checked="!customLimits" :disabled="disabled" class="mb-3" @change="value => toggleLimits(!value)">Use main limits for bonus chips</b-form-checkbox>
    <b-row v-if="customLimits">
      <b-col v-for="field in fields" :key="field.path.join('.')" cols="12" sm="6">
        <b-form-group :label="field.label" :label-for="'bonus-limit-' + _uid + '-' + field.path.join('-')">
          <b-form-input :id="'bonus-limit-' + _uid + '-' + field.path.join('-')" :value="field.value" type="number" min="0" step="any" :disabled="disabled" required @input="value => setLimit(field.path, value)" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>
  </fieldset>
</template>

<script>
import Vue from 'vue'
import { bonusSettingsError } from './bonus-settings'

const clone = value => JSON.parse(JSON.stringify(value))
export default {
  props: { settings: { type: Object, required: true }, disabled: Boolean },
  data: () => ({ chipDraft: null, limitDraft: null }),
  computed: {
    customChips() { return this.settings.bonusChips != null },
    customLimits() { return this.settings.bonusLimits != null },
    effectiveLimits() { return { ...this.settings.limit, ...(this.settings.bonusLimits || {}) } },
    error() { return bonusSettingsError(this.settings) },
    fields() {
      const fields = []
      const visit = (values, path = [], prefix = '') => {
        Object.entries(values).forEach(([key, value]) => {
          const next = [...path, key]
          if (/(?:^|_)(min|max)$/.test(key)) {
            fields.push({ path: next, value, label: prefix + key.replace(/_/g, ' ') })
          } else if (value && typeof value === 'object') {
            const label = value.title || value.key || (Array.isArray(values) ? 'Side bet ' + (Number(key) + 1) : key)
            visit(value, next, prefix + label + ' / ')
          }
        })
      }
      visit(this.effectiveLimits)
      return fields
    }
  },
  methods: {
    toggleChips(enabled) {
      if (this.disabled) return
      if (!enabled) this.chipDraft = clone(this.settings.bonusChips)
      const first = this.settings.chips?.[0] || {}
      const nominal = this.settings.limit?.straight_up_min || this.settings.limit?.player_min || first.nominal || 1
      Vue.set(this.settings, 'bonusChips', enabled ? clone(this.chipDraft || [{ ...first, nominal }]) : null)
    },
    toggleLimits(enabled) {
      if (this.disabled) return
      if (!enabled) this.limitDraft = clone(this.settings.bonusLimits)
      Vue.set(this.settings, 'bonusLimits', enabled ? clone(this.limitDraft || this.settings.limit || {}) : null)
    },
    addChip() {
      if (this.disabled) return
      this.settings.bonusChips.push({ nominal: '', position: this.settings.bonusChips.length })
    },
    setLimit(path, value) {
      if (this.disabled || !this.customLimits) return
      const top = path[0]
      if (path.length > 1 && !Object.prototype.hasOwnProperty.call(this.settings.bonusLimits, top)) {
        Vue.set(this.settings.bonusLimits, top, clone(this.effectiveLimits[top]))
      }
      let target = this.settings.bonusLimits
      path.slice(0, -1).forEach(key => { target = target[key] })
      Vue.set(target, path[path.length - 1], value === '' ? '' : Number(value))
    }
  },
  watch: { settings() { this.chipDraft = null; this.limitDraft = null } }
}
</script>

<style scoped>
.bonus-limits-editor { min-width: 0; }
</style>
